import React from 'react';

export const Input: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = ({
  className,
  ...props
}) => (
  <input className={`px-4 py-2 border border-black ${className}`} {...props} />
);
